function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17,5l-3-3h-4L7,5H17z"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  x2: 20,
  y1: 4,
  y2: 4,
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 14,
  x2: 14,
  y1: 18,
  y2: 7,
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 10,
  x2: 10,
  y1: 18,
  y2: 7,
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M6,4v16c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V4"
});

var SvgTrashNew = function SvgTrashNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash-new.845a7d62.svg";
export { ForwardRef as ReactComponent };